import { Component, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { BaseComponent } from '@app/core/components/base/base.component';
import { MenuUtilService } from '@app/core/services/util/menu-util.service';
import { PonchoUIModule } from '@poncho/ui';
import { NgClass } from '@angular/common';
import { DeferImageLoadDirective } from '../../directives/defer-image-load.directive';

@Component({
    selector: 'app-product-view',
    templateUrl: './product-view.component.html',
    styleUrls: ['./product-view.component.scss'],
    standalone: true,
    imports: [DeferImageLoadDirective, NgClass, PonchoUIModule]
})
export class ProductViewComponent extends BaseComponent implements OnInit {
    @Input() product: any;
    @Input() menuModel: any;
    @Input() product_prices: any;
    @Input() quantity: number;

    destroySubject$: Subject<void> = new Subject();
    constructor(private menuUtilService: MenuUtilService) {
        super();
    }

    updateCart(operation, productId) {
        this.menuUtilService.updateCart(operation, productId, this.menuModel);
    }
}
